export var getIsMobile = function getIsMobile() {
  return window.innerWidth < 1024;
};